module.exports = __webpack_public_path__ + "img/change.f602eba.svg";